export default [
  {
    label: 'SIDE_NAV_PROFILE_CTA',
    name: 'profile',
    url: { name: 'settings-profile' }
  },
  {
    label: 'SIDE_NAV_MEMBERSHIP_CTA',
    name: 'membership',
    url: { name: 'settings-membership' }
  },
  {
    label: 'SIDE_NAV_PERKS_CTA',
    name: 'member-benefits',
    url: { name: 'settings-member-benefits' }
  },
  {
    label: 'SIDE_NAV_PAYMENT_CTA',
    name: 'payment',
    url: { name: 'settings-payment' }
  },
  {
    label: 'EXPLORE_EVENTS_PREVIOUS_BOOKINGS_TITLE',
    name: 'previous-bookings',
    url: { name: 'settings-previous-bookings' }
  },
  {
    label: 'SIDE_NAV_PASSWORD_CTA',
    name: 'password',
    url: { name: 'settings-password' }
  },
  {
    label: 'SIDE_NAV_PREFERENCES_CTA',
    name: 'houses',
    url: { name: 'settings-houses' }
  },
  {
    label: 'SIDE_NAV_NOTIFICATIONS_CTA',
    name: 'preferences',
    url: { name: 'settings-preferences' }
  },
  {
    label: 'SIDE_NAV_CALENDAR_CTA',
    name: 'calendar',
    url: { name: 'settings-calendar' }
  },
  {
    label: 'SIDE_NAV_APPLICATIONS_CTA',
    name: 'applications',
    url: { name: 'settings-applications' }
  },
  {
    label: 'SIDE_NAV_LOGOUT_CTA',
    name: 'logout',
    url: { name: 'logout' }
  }
]
